import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, BOOK_TITLE, BOOK_SUBTITLE, BOOK_TAGLINE, BOOK_AUDIENCE } from '../data/content';
const trustItems = [{
  icon: DownloadIcon,
  label: 'Descarga instantánea'
}, {
  icon: ShieldCheckIcon,
  label: 'Pago seguro vía Hotmart'
}, {
  icon: ZapIcon,
  label: 'Actualizaciones incluidas'
}];
export function Hero() {
  return <section className="relative overflow-hidden border-b border-carbon-800 bg-carbon-950" data-id="element-39" data-mp="xanojyp8dfeu">
      <div className="bg-grid absolute inset-0" aria-hidden="true" data-id="element-40" data-mp="sbb1bcug66bq" />
      <div className="absolute -top-40 left-1/4 h-96 w-96 rounded-full bg-volt/10 blur-[120px]" aria-hidden="true" data-id="element-41" data-mp="s9giq56neqat" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:gap-10 lg:py-24" data-id="element-42" data-mp="3d1a4l90jrr80">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-43" data-mp="381e6fqej6u0d">
          <span className="inline-flex items-center gap-2 rounded-full border border-carbon-700 bg-carbon-850 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-safety" data-id="element-44" data-mp="3o85cdefo0765">
            <span className="h-1.5 w-1.5 rounded-full bg-safety" aria-hidden="true" data-id="element-45" data-mp="3e9607lvoxtee" />
            Edición Audio &amp; Video
          </span>

          <h1 className="mt-6 text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-46" data-mp="30h9cdu1225nt">
            {BOOK_TITLE}
          </h1>

          <p className="mt-5 max-w-xl text-base font-semibold leading-snug text-slate-300 sm:text-lg" data-id="element-47" data-mp="2qk3kwkoj4cn2">
            {BOOK_SUBTITLE}
          </p>

          <p className="mt-5 max-w-xl text-lg font-bold leading-relaxed text-safety" data-id="element-48" data-mp="2vjpvemcz3es6">
            {BOOK_TAGLINE}
          </p>

          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-400" data-id="element-49" data-mp="2hl9r122l20d7">{BOOK_AUDIENCE}</p>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-50" data-mp="2lmuyu909fogj">
            <CtaButton label={`Obtener mi copia por ${PRICE}`} data-id="element-51" data-mp="s3mf683jc910" />
            <a href="#oferta" className="text-sm font-semibold text-slate-400 underline-offset-4 transition-colors hover:text-white hover:underline" data-id="element-52" data-mp="nb1jf112jluu">
              Ver qué incluye
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 border-t border-carbon-800 pt-6" data-id="element-53" data-mp="db2fjhflgjob">
            {trustItems.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm text-slate-500" data-id="element-54" data-mp="16342sk53hg8s">
                <Icon className="h-4 w-4 text-volt" aria-hidden="true" data-id="element-55" data-mp="111etb8xitamt" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative" data-id="element-56" data-mp="3lsp3vew9yley">
          <div className="overflow-hidden rounded-xl border border-carbon-700 bg-carbon-900 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)]" data-id="element-57" data-mp="1xacgp6hknput">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/4d57cbdb-f74e-4b43-9093-04030fd1f63e.jpg" alt="eBook La Biblia de las Fallas Típicas junto a un multímetro digital sobre un mesón de taller" className="h-full w-full object-cover" data-id="element-58" data-mp="218toztcqb6dt" />
          </div>
          <div className="absolute -bottom-5 left-5 rounded-md border border-carbon-700 bg-carbon-850 px-4 py-3 shadow-xl sm:left-8" data-id="element-59" data-mp="2kyn9dmd46j80">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500" data-id="element-60" data-mp="2p1jv3lxyavg6">
              Formato
            </p>
            <p className="text-sm font-bold text-white" data-id="element-61" data-mp="2txhddxsrybvl">PDF digital · Acceso inmediato</p>
          </div>
        </motion.div>
      </div>
    </section>;
}